var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4618 11.7696H23.0412C23.0412 5.64756 18.0882 0.666992 12 0.666992C11.4612 0.666992 11.0244 1.1062 11.0244 1.64798C11.0244 2.18975 11.4612 2.62896 12 2.62896C17.0122 2.62896 21.0901 6.72941 21.0901 11.7696H20.6696C20.2559 11.7696 19.9973 12.2198 20.2041 12.5801L21.6003 15.0117C21.8071 15.3719 22.3243 15.3719 22.5311 15.0117L23.9272 12.5801C24.134 12.2199 23.8754 11.7696 23.4618 11.7696Z",
    fill: "#494949",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9103C6.9877 20.9103 2.9099 16.8098 2.9099 11.7697H3.33042C3.74404 11.7697 4.00265 11.3194 3.79575 10.9591L2.39962 8.52748C2.19281 8.16727 1.67568 8.16727 1.46887 8.52748L0.0727882 10.9592C-0.134025 11.3194 0.124491 11.7697 0.538117 11.7697H0.958633C0.958633 17.8917 5.91169 22.8723 11.9999 22.8723C12.5386 22.8723 12.9754 22.4331 12.9754 21.8913C12.9756 21.3495 12.5387 20.9103 12 20.9103Z",
    fill: "#494949",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8668 10.7906V9.92822C11.3416 10.0339 11.1622 10.4922 11.8668 10.7906Z",
    fill: "#494949",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2703 12.1313V13.1025C12.5153 13.0445 12.7099 12.9068 12.7099 12.6459C12.7099 12.4068 12.5298 12.2546 12.2703 12.1313Z",
    fill: "#494949",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.62671C8.08313 4.62671 4.89661 7.83098 4.89661 11.7695C4.89661 15.7081 8.08313 18.9123 12 18.9123C15.9168 18.9123 19.1033 15.7081 19.1033 11.7695C19.1033 7.83098 15.9167 4.62671 12 4.62671ZM12.3424 14.1097V14.3198C12.3424 14.4213 12.2055 14.5154 12.0685 14.5154C11.91 14.5154 11.7947 14.4213 11.7947 14.3198V14.1386C10.9299 14.1097 10.2236 13.6603 10.2236 13.1965C10.2236 12.9501 10.4399 12.5878 10.7137 12.5878C11.0164 12.5878 11.2614 13.0154 11.7948 13.1096V11.9356C11.1318 11.682 10.3534 11.3704 10.3534 10.4428C10.3534 9.52239 11.0309 9.08035 11.7948 8.97166V8.76874C11.7948 8.6673 11.9101 8.57308 12.0686 8.57308C12.2055 8.57308 12.3425 8.6673 12.3425 8.76874V8.94997C12.7893 8.96449 13.6325 9.08045 13.6325 9.58041C13.6325 9.77607 13.5028 10.1746 13.1857 10.1746C12.9479 10.1746 12.8109 9.94274 12.3425 9.90649V10.9645C12.9983 11.211 13.7622 11.5516 13.7622 12.5299C13.7621 13.4285 13.1857 13.972 12.3424 14.1097Z",
    fill: "#494949",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSwitch);
export default __webpack_public_path__ + "static/media/light-switch.018e178f.svg";
export { ForwardRef as ReactComponent };